import { petApi, GetDagRunsBatchApiResponse, GetDagRunsBatchApiArg } from './airflowApi';

export const extendedPetApi = petApi.injectEndpoints({
    endpoints: build => ({
        getDagRunsBatchCustom: build.query<GetDagRunsBatchApiResponse, GetDagRunsBatchApiArg>({
            query: queryArg => ({ url: `/dags/~/dagRuns/list`, method: 'POST', body: queryArg.listDagRunsForm }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetConnectionsQuery,
    usePostConnectionMutation,
    useGetConnectionQuery,
    usePatchConnectionMutation,
    useDeleteConnectionMutation,
    useTestConnectionMutation,
    useGetDagsQuery,
    usePatchDagsMutation,
    useGetDagQuery,
    usePatchDagMutation,
    useDeleteDagMutation,
    usePostClearTaskInstancesMutation,
    useSetTaskInstanceNoteMutation,
    useSetMappedTaskInstanceNoteMutation,
    usePostSetTaskInstancesStateMutation,
    useGetDagRunsQuery,
    usePostDagRunMutation,
    useGetDagRunsBatchMutation,
    useGetDagRunQuery,
    useDeleteDagRunMutation,
    useUpdateDagRunStateMutation,
    useClearDagRunMutation,
    useGetUpstreamDatasetEventsQuery,
    useSetDagRunNoteMutation,
    useGetEventLogsQuery,
    useGetEventLogQuery,
    useGetImportErrorsQuery,
    useGetImportErrorQuery,
    useGetPoolsQuery,
    usePostPoolMutation,
    useGetPoolQuery,
    usePatchPoolMutation,
    useDeletePoolMutation,
    useGetProvidersQuery,
    useGetTaskInstancesQuery,
    useGetTaskInstanceQuery,
    usePatchTaskInstanceMutation,
    useGetMappedTaskInstanceQuery,
    usePatchMappedTaskInstanceMutation,
    useGetMappedTaskInstancesQuery,
    useGetTaskInstancesBatchMutation,
    useGetVariablesQuery,
    usePostVariablesMutation,
    useGetVariableQuery,
    usePatchVariableMutation,
    useDeleteVariableMutation,
    useGetXcomEntriesQuery,
    useGetXcomEntryQuery,
    useGetExtraLinksQuery,
    useGetLogQuery,
    useGetDagDetailsQuery,
    useGetTasksQuery,
    useGetTaskQuery,
    useGetDagSourceQuery,
    useGetDagWarningsQuery,
    useGetDatasetsQuery,
    useGetDatasetQuery,
    useGetDatasetEventsQuery,
    useGetConfigQuery,
    useGetHealthQuery,
    useGetVersionQuery,
    useGetPluginsQuery,
    useGetRolesQuery,
    usePostRoleMutation,
    useGetRoleQuery,
    usePatchRoleMutation,
    useDeleteRoleMutation,
    useGetPermissionsQuery,
    useGetUsersQuery,
    usePostUserMutation,
    useGetUserQuery,
    usePatchUserMutation,
    useDeleteUserMutation,
    useGetDagRunsBatchCustomQuery,
} = extendedPetApi;
